<template>
  <div class="box">
    <!-- 沉浸式头部 -->
    <div class="bridge-list">
      <rich-button @click="goUrl('非沉浸式头部')">非沉浸式头部</rich-button>
      <van-field
        v-model="JSON.stringify(immersion)"
        rows="1"
        :formatter="formatter"
        autosize
        label="参数设置："
        type="textarea"
        placeholder="参数设置"
      />
    </div>
    <div class="bridge-list">
      <rich-button @click="goUrl('沉浸式头部')">沉浸式头部</rich-button>
       <van-field
        v-model="JSON.stringify(noImmersion)"
        rows="1"
        autosize
        label="参数设置："
        type="textarea"
        placeholder="参数设置"
      />
    </div>
    <div
      v-for="(item, index) of bridgeList"
      :key="index"
      class="bridge-list"
      @click="clickBridge(item, index)"
    >
      <div>bridge描述：{{ item.name }}</div>
      <div>
        bridge点击：<rich-button>{{ item.key }}</rich-button>
      </div>
      <div>bridge返回的参数：{{ item.detail }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Field } from 'vant';

Vue.use(Field);

export default {
  data() {
    return {
      options: ["left", "center"],
      bridgeList: [
        {
          id: 0,
          name: "获取全局公参",
          key: "getGlobalParams",
          detail: "",
        },
        {
          id: 1,
          name: "打开某个h5页面",
          key: "openPage",
          detail: "",
        },
        {
          id: 2,
          name: "获取用户信息",
          key: "getUserInfo",
          detail: "",
        },
        {
          id: 3,
          name: "检查是否为旧版本（小于7.1.30）嵌入端的时候使用到了",
          key: "getSystemInfo",
          detail: "",
        },
        {
          id: 4,
          name: "选择券",
          key: "selectCoupon",
          detail: "",
        },
        {
          id: 5,
          name: "关闭当前页面",
          key: "closePage",
          detail: "",
        },
        {
          id: 6,
          name: "取消订单",
          key: "cancelOrder",
          detail: "",
        },
      ],
      immersion: {
       bgColor : "#123456",
        titleColor : "#123456",
        navStyle : 1, // 1：light，0：dark
        shadowHidden : 0,  // 0：展示，1：隐藏
        position: "left"
      },
      noImmersion: {
        sysStatusBar: 1, // 0黑色,1白色
        backBtn: {
          // 返回按钮
          alpha: 1, // 透明度
          color: '#000000' // 字体颜色
        },
        title: {
          color: '#000000',
          alpha: 1,
          content: this.$t('FoodC_C_Coupon_package_aeUS')
        },
        nav: {
          color: '#FFFFFF',
          alpha: 1
        },
        // rightBtns: [ // titlebar右边按钮
        //   {
        //     name: 'shareBtn',
        //     alpha: 1,
        //     currentIcon: '', // 实际图 cdn链接
        //     preloadIcon: '', // 预加载图
        //     action: 'triggerShareButtonEvent'
        //   }
        // ]
        rightBtns: [
          {
            type: 1,
            alpha: 1,
            color: '#000000',
            title: this.$t('FoodC_C_Purchase_Records_CIUH'),
            action: 'triggerShareButtonEvent'
          }
        ]
      },
    };
  },
  methods: {
    async clickBridge(item, index) {
      if (item.key === "getGlobalParams") {
        const globalParamsRes =
          (await SodaBridge("getGlobalParams", "badcase")) || {};
        this.bridgeList[index].detail = globalParamsRes;
      } else if (item.key === "openPage") {
        this.SodaBridge(item.key, {
          target: "blank",
          url: "https://www.baidu.com/",
        });
      } else if (item.key === "selectCoupon") {
        this.SodaBridge("sodaEntrega.selectCoupon", {
          coupon_id: "优惠券id",
          bill_coupon_type: "券类型",
          relate_id: "",
        })
          .then((info) => {
            this.bridgeList[index].detail = info;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (item.key === "closePage") {
        this.SodaBridge("closePage");
      } else if (item.key === "cancelOrder") {
        this.SodaBridge("sodaEntrega.cancelOrder", {
          params: "测试参数",
        });
      } else {
        const res = (await SodaBridge(item.key)) || {};
        this.bridgeList[index].detail = res.data;
      }
    },
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/\d/g, '');
    },
    goUrl(type) {
      const origin = window.location.origin
      if(type==='非沉浸式头部') {
        window.SodaBridge('openPage', {
          target: 'blank',
          url:origin + '/titleTestPage?type='+encodeURIComponent(JSON.stringify(type))+'&immersion='+encodeURIComponent(JSON.stringify(this.immersion))
        })
      }else {
        window.SodaBridge('openPage', {
          target: 'blank',
          url:origin + '/titleTestPage?nativeWebUIType=1&type='+encodeURIComponent(JSON.stringify(type))+'&noImmersion='+encodeURIComponent(JSON.stringify(this.noImmersion))
        })
        
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.box {
   overflow: scroll;
   height: 100%
}
.bridge-list{
    border: 1px solid #ccc;
    margin: 30px;
}
</style>
